'use client';

import { Button } from '@/core/ui/primitives/button';
import { Card, CardContent, CardFooter, CardHeader, CardTitle, CardDescription } from '@/core/ui/primitives/card';
import { useState } from 'react';
import { Building03Icon, SecurityLockIcon } from 'hugeicons-react';
import Image from 'next/image';

export default function AuthPage({
  params: _params,
}: {
  params: Promise<{ path: string }>;
}) {
  const [loading, setLoading] = useState(false);

  const handleSSOSignIn = async () => {
    setLoading(true);
    const isTauri = '__TAURI_INTERNALS__' in window;

    if (isTauri) {
      // Open SSO in system browser so password managers work
      // source=desktop tells the server to redirect back via deep link
      const { open } = await import('@tauri-apps/plugin-shell');
      const appUrl = window.location.origin;
      await open(`${appUrl}/api/saml/login?callbackUrl=/&source=desktop`);
    } else {
      window.location.href = '/api/saml/login?callbackUrl=/';
    }
  };

  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center gap-3">
          <Image
            src="/soul-studios-logo.png"
            alt="Soul Studios"
            width={48}
            height={48}
            className="h-12 w-12 object-contain"
            priority
          />
          <div className="text-center">
            <p className="text-xs font-medium uppercase tracking-[0.2em] text-muted-foreground">
              Soul Studios
            </p>
            <h1 className="text-xl font-semibold tracking-tight text-foreground">
              Team Hub
            </h1>
          </div>
        </div>

        <Card>
          <CardHeader>
            <CardTitle className="text-center text-base">Welcome back</CardTitle>
            <CardDescription className="text-center">
              Sign in to access your workspace
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button
              size="lg"
              className="w-full"
              onClick={handleSSOSignIn}
              disabled={loading}
            >
              <Building03Icon className="size-4" />
              {loading ? 'Redirecting...' : 'Sign in with SSO'}
            </Button>
          </CardContent>
          <CardFooter className="justify-center">
            <div className="flex items-center gap-1.5 text-[0.6875rem] text-muted-foreground">
              <SecurityLockIcon className="size-3" />
              <span>SAML single sign-on</span>
            </div>
          </CardFooter>
        </Card>
      </div>
    </main>
  );
}
